<script setup>
// Image Tools 分类枢纽 /free-tools/image/（nuxt#19 P2）。
import "@/assets/styles/free-tools.css";
definePageMeta({ layout: "free-tools" });
const GROUP = ["image", "camera", "generate", "design", "ai", "vector", "embroidery", "icon", "cad", "misc"];
useHead({
  title: "Free Image Tools — Convert, Compress & Edit Images | SharkFoto",
  meta: [{ name: "description", content: "Free image tools: convert, compress, resize, crop, edit and more — every image, raw, vector and icon format. Common formats in your browser, advanced ones on our secure servers, never stored. No sign-up, no watermark." }],
  link: [{ rel: "canonical", href: "https://sharkfoto.com/free-tools/image/" }],
  script: [{ type: "application/ld+json", innerHTML: JSON.stringify({ "@context": "https://schema.org", "@type": "CollectionPage", name: "Free Image Tools", url: "https://sharkfoto.com/free-tools/image/" }) }],
});
</script>

<template>
  <FreeToolsHub :group="GROUP" :crumb="[['Home', 'https://sharkfoto.com/'], ['Free Tools', 'https://sharkfoto.com/free-tools/'], ['Image', '']]" title-prefix="Free image tools" intro="Convert, compress, resize, crop and edit images — every format from JPG and PNG to camera raw, vector, icon and CAD. Common formats run right in your browser; advanced ones use our secure servers and are never stored." />
</template>
